import { Tag, TagLabel, TagProps } from '@chakra-ui/react';
import { AUDIENCE_GENDER } from '~/constants';
import { myAgencyCreatorCardTrackId } from '~/screens/MyAgency/components/StackView/CreatorInfo/constants';
import { ICreator } from '~/types';

import { genderOptions } from './GenderTag.model';
import { getGenderFromValue } from './GenderTag.utils';

interface IGenderTagProps extends TagProps {
  creator: ICreator;
}

export const GenderTag: React.FC<IGenderTagProps> = ({ creator, ...props }) => {
  const { genderAgency: gender } = creator;

  const genderKey =
    gender === genderOptions[AUDIENCE_GENDER.nonBinary].name
      ? AUDIENCE_GENDER.nonBinary
      : (gender as string)?.charAt(0);

  const { value: text, color } = getGenderFromValue(genderKey);

  return (
    <>
      {text && (
        <Tag
          size="md"
          width="24px"
          height="24px"
          fontSize="sm"
          borderRadius="full"
          variant="outline"
          justifyContent="center"
          color={color}
          colorScheme={color}
          border={`1px solid ${color}`}
          track-id={myAgencyCreatorCardTrackId.gender}
          {...props}
        >
          <TagLabel overflow="initial">{text}</TagLabel>
        </Tag>
      )}
    </>
  );
};
